import {
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_AII,
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_FF,
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_IPG,
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_LAB,
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_LPT,
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_MPP,
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_PLA,
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_RCH,
    CONTACT_PAGE_BUSINESS_UNIT_TEXT_SGO
} from '../configuration/contact-page';

export const BUSINESS_UNITS: Record<string, string> = {
    '01': CONTACT_PAGE_BUSINESS_UNIT_TEXT_AII,
    '02': CONTACT_PAGE_BUSINESS_UNIT_TEXT_IPG,
    '05': CONTACT_PAGE_BUSINESS_UNIT_TEXT_RCH,
    '06': CONTACT_PAGE_BUSINESS_UNIT_TEXT_LPT,
    '07': CONTACT_PAGE_BUSINESS_UNIT_TEXT_PLA,
    '08': CONTACT_PAGE_BUSINESS_UNIT_TEXT_MPP,
    '10': CONTACT_PAGE_BUSINESS_UNIT_TEXT_SGO,
    '12': CONTACT_PAGE_BUSINESS_UNIT_TEXT_LAB,
    '13': CONTACT_PAGE_BUSINESS_UNIT_TEXT_FF
};

export function mapBusinessUnitToText(number: string): string {
    // eslint-disable-next-line security/detect-object-injection
    return BUSINESS_UNITS[number] || '';
}
